<template>
    <div class="card-details-buyer">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <span><b>Detalles de mi compra</b></span>
                        <hr>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span><strong>Transacción:</strong> {{transaction}}</span>
                    </div>
                    <div class="col-6">
                        <span><strong>Fecha:</strong> {{date}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span><strong>Nombre completo:</strong> {{name}}</span>
                    </div>
                    <div class="col-6">
                        <span><strong>{{documentType}}:</strong> {{document}}</span>
                    </div>
                    <div class="col-6">
                        <span><strong>Correo:</strong> {{email}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <span><strong>Total:</strong> S/. {{total}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
export default {
    props: {
        user: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        },
        transactionId:{
            type: String,
            default: ""
        },
        totalPay:{
            type: Number,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: 0
        }
    },
    data() {
        return {
            buyer: ''
        }
    },
    computed: {
        name() {
            return this.user.name ? this.user.name : this.nameBuyer
        },
        documentType() {
            return this.user.documentType ? this.user.documentType : this.userFeePayments.documentType
        },
        document(){
            return this.user.document ? this.user.document : this.userFeePayments.document
        },
        email(){
            return this.user.email ? this.user.email : this.userFeePayments.email
        },
        transaction(){
            return this.transactionId
        },
        total(){
            return this.totalPay
        },
        isCreateFeePayment() {
            return this.$store.state.feePayments.isCreate;
        },
        date(){
            return this.isCreateFeePayment ? this.getDate() : this.userFeePayments.paymentDate
        },
        nameBuyer(){
            if (this.userFeePayments) return `${this.userFeePayments.firstName} ${this.userFeePayments.lastName}`
            return ''
        },
        userFeePayments(){
            return this.$store.getters.getUserFeePayment;
        }

    },
    methods: {
        getDate() {
            const date = moment().format("DD/MM/YYYY");
            return date; 
        },
    },
}
</script>